var jade = require("D:\\Jenkins670\\workspace\\D_PIPELINE_release_658967.5.66.0\\JAVA\\ui\\group_ui\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (isLoggedIn) {
var linkId = (isLoggedIn === true) ? 'navbar-logout-link' : 'navbar-login-link'
var linkClass = (isLoggedIn === true) ? 'webchat-myvhi-logout' : 'webchat-myvhi-login'
var btnText = (isLoggedIn === true) ? 'common:header.logout' : 'common:header.login'
var url =  (isLoggedIn === true) ? "javascript:window.location.href='logout';" : '/myvhi'
buf.push("<a" + (jade.attr("id", '' + (linkId) + '', true, true)) + (jade.attr("href", '' + (url) + '', true, true)) + (jade.cls(['navbar-login-link ' + (linkClass) + ''], [true])) + "><button id=\"navbar-login-btn\"" + (jade.attr("data-i18n", "" + (btnText) + "", true, true)) + " class=\"navbar-login-btn\">Log out</button></a>");}.call(this,"isLoggedIn" in locals_for_with?locals_for_with.isLoggedIn:typeof isLoggedIn!=="undefined"?isLoggedIn:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/main/jade/templates/landing/navbarLoginButton.jade
// module id = 7Iys
// module chunks = 0 1 2 3 4 5 6 7 8